import Config from '../Config';
import moment from 'moment';
import {format} from '../Utils';
import { RestService } from './RestService';

export const ExportService = {
    export: async function(date){
        return RestService.get(`${Config.export_excel}date=${moment.utc(date).format(format)}`, {})
        .then(response => response.json());
    },
};